var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('navheader'),_c('div',{staticClass:"content"},[_c('router-view'),_c('el-backtop',{attrs:{"target":".wrapper","bottom":100}})],1),_c('footeritem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }